import { render } from "./ReviewsSection.vue?vue&type=template&id=46615796"
import script from "./ReviewsSection.vue?vue&type=script&lang=js"
export * from "./ReviewsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__